module.exports = __webpack_public_path__ + "img/four4Red.838f09ca.jpg";